import type { ComponentPropsWithRef } from 'react'

import classNames from 'classnames'

export const Paragraph: React.FC<ComponentPropsWithRef<'p'>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <p
      className={classNames(
        'type-body-base pt-2 group-[.no-text-padding]:pt-0',
        className,
      )}
      {...props}
    >
      {children}
    </p>
  )
}
